const EXPLAINERS = Object.freeze({
  SHAPE_HAS_ASSOCIATED_ITEMS: "Whoa boss. Looks like there are items associated with this shape. I can't delete it before the items are deleted too.",
  PRODUCT_VARIANT_SKU_IN_USE: 'Turns out this SKU is taken by another product of yours. Can you come up with a different one?',
  PRODUCT_VARIANT_SKU_NOT_UNIQUE: 'This SKU is being used more than once. Each product variant wants to be special, so give them a unique SKU so that I can tell them apart.'
});
export function explainError({
  extensions
} = {}) {
  return EXPLAINERS[extensions === null || extensions === void 0 ? void 0 : extensions.code];
}